/* eslint-disable tailwindcss/no-custom-classname */

export function Terms() {
  return (
    <>
      <header>카카오페이지 이용약관</header>
      <main>
        <section>
          <h2>제1장 총칙</h2>
          <section>
            <h3>제 1 조 (목적)</h3>
            <p>
              본 약관은 (주)카카오엔터테인먼트(이하 "회사"라 합니다)가 제공하는
              카카오페이지 서비스(이하 "서비스"라 합니다)의 이용과 관련하여
              회원과 회사 간의 권리와 의무, 책임사항, 기타 필요한 사항을
              규정함을 목적으로 합니다.
            </p>
          </section>
          <section>
            <h3>제 2 조 (용어의 정의)</h3>
            <ol>
              <li className="number-circle-li">
                <span>①</span>본 약관에서 사용하는 용어의 정의는 다음과
                같습니다.
                <ol className="inner-ol">
                  <li>
                    <span>1.</span>
                    "서비스"라 함은 회사가 회원에게 유·무선 접근기기를 통해
                    제공하는 콘텐츠 및 관련 정보와 소프트웨어 등을 의미합니다.
                  </li>
                  <li>
                    <span>2.</span>
                    "회원"이라 함은 본 약관 및 개인정보 제공에 동의하고,
                    회사로부터 서비스 이용 자격을 부여 받은 이용자를 의미합니다.
                  </li>
                  <li>
                    <span>3.</span>
                    "콘텐츠"라 함은 디지털 방식으로 제작, 처리되어 회원에게
                    서비스되는 내용물 일체(글, 그림, 사진, 음성, 음향, 동영상
                    등)를 의미합니다.
                  </li>
                  <li>
                    <span>4.</span>
                    "유료서비스"라 함은 회사가 유료로 제공하는 제1호의 서비스를
                    의미합니다.
                  </li>
                  <li>
                    <span>5.</span>
                    "접근기기"라 함은 휴대전화, PC, 태블릿 등 콘텐츠를 다운로드
                    받아 설치하여 이용하거나 콘텐츠를 네트워크를 통해 이용할 수
                    있도록 해 주는 기계적 수단을 의미합니다.
                  </li>
                  <li>
                    <span>6.</span>
                    "캐시"라 함은 회원이 콘텐츠 또는 이용권 구매 시 사용할 수
                    있도록 회사가 내용과 조건을 정하여 제공하는 전자적 지급
                    수단을 의미합니다. 회원이 캐시를 충전한 날로부터 5년이
                    경과할 때까지 캐시를 이용하지 않을 경우 상사소멸시효에 따라
                    소멸될 수 있으며, 무상으로 제공된 캐시의 경우 사전에 고지한
                    회사의 정책에 따라 소멸될 수 있습니다. 캐시의 구매에 관한
                    자세한 사항은 당사의 이용정책, 카카오 전자금융거래 이용약관
                    및 앱마켓의 정책을 통해 확인하실 수 있습니다.
                  </li>
                  <li>
                    <span>7.</span>
                    "이용권"이라 함은 회원이 유료서비스의 이용을 위해 사용할 수
                    있도록 회사가 내용과 조건을 정하여 제공하는 전자적 지급
                    수단을 의미합니다. 이용권은 캐시로 구매할 수 있으며 이용권의
                    종류, 사용방법 등에 대해서는 이용권 구매 시 화면에서
                    회원에게 안내합니다. 회원이 이용권의 구매일로부터 5년이
                    경과할 때까지 이용하지 않을 경우 상사소멸시효에 따라 소멸될
                    수 있습니다. 다만 무상으로 제공된 이용권의 경우 사전에
                    고지한 회사의 정책에 따라 소멸될 수 있습니다.
                  </li>
                </ol>
              </li>
              <li className="number-circle-li">
                <span>②</span>본 약관에서 사용하는 용어의 정의는 본 조 제1항
                각호에서 정하는 것을 제외하고는 개별 이용약관, 서비스 가이드,
                관계 법령, 기타 일반 상관례에 따릅니다.
              </li>
            </ol>
          </section>
          <section>
            <h3>제 3 조 (약관의 게시, 개정 등)</h3>
            <ol>
              <li className="number-circle-li">
                <span>①</span>
                회사는 본 약관의 내용을 회원이 쉽게 확인할 수 있도록 서비스 초기
                화면 또는 팝업화면 등 별도의 연결화면에 게시합니다.
              </li>
              <li className="number-circle-li">
                <span>②</span>
                회사는 「콘텐츠산업진흥법」, 「전자상거래 등에서의 소비자보호에
                관한 법률」, 「약관의 규제에 관한 법률」, 「정보통신망이용촉진
                및 정보보호 등에 관한 법률」 등 관계 법령을 위반하지 않는 범위
                내에서 본 약관을 개정할 수 있습니다.
              </li>
              <li className="number-circle-li">
                <span>③</span>
                회사가 본 약관을 개정할 경우에는 개정 약관의 적용일자 및
                개정사유를 명시하여 현행 약관과 함께 회사가 운영하는 서비스 내의
                적절한 장소에 개정 약관의 적용일자 15일 전부터 적용일자 전일까지
                공지합니다. 다만, 회원에게 불리하게 약관내용을 개정하는 경우에는
                적용일자 30일 전부터 공지하고, 회원이 가입 시 제공한 전자우편
                등의 전자적 수단을 통하여 고지합니다.
              </li>
              <li className="number-circle-li">
                <span>④</span>
                회사가 본 조 제3항에 따라 15일 또는 30일 전에 개정 약관을 공지
                또는 고지하면서 "개정 약관 적용일 전까지 회원이 명시적으로
                거부의사를 표시하지 아니할 경우 약관의 개정에 동의한 것으로
                간주한다"는 뜻을 명확하게 공지 또는 고지하였음에도, 회원이
                명시적으로 약관 변경에 대한 거부의 의사표시를 하지 아니한
                경우에는 회원이 개정 약관에 동의한 것으로 간주합니다.
              </li>
              <li className="number-circle-li">
                <span>⑤</span>
                회원이 개정 약관의 적용에 동의하지 않는 경우 회사는 해당 회원에
                대하여 개정 약관의 내용을 적용할 수 없으며, 이 경우 개정 약관의
                적용에 동의하지 않는 회원은 본 약관에 따른 서비스 이용계약을
                해지할 수 있습니다. 다만, 회사가 개정 약관에 동의하지 않은
                회원에 대하여 기존 약관을 더 이상 적용할 수 없는 사정이 있는
                경우에 회사는 해당 회원에 대하여 본 약관에 따른 서비스
                이용계약을 해지할 수 있습니다.
              </li>
              <li className="number-circle-li">
                <span>⑥</span>본 약관은 회원이 본 약관에 동의한 날로부터 탈퇴할
                때까지 적용하는 것을 원칙으로 합니다. 다만, 제20조(분쟁조정의
                신청), 제21조(준거법 및 재판관할) 등 본 약관 조항의 성질상 탈퇴
                이후에도 적용 가능한 항목들은 회원이 탈퇴한 후에도 경우에 따라
                회사와 회원 사이에 유효하게 적용될 수 있습니다.
              </li>
            </ol>
          </section>
          <section>
            <h3>제 4 조 (회원에 대한 통지)</h3>
            <ol>
              <li className="number-circle-li">
                <span>①</span>
                회사가 회원에 대한 통지를 하는 경우, 본 약관에서 통지방법에
                대하여 별도로 정하지 않는 한 회원이 가입할 때 제공한 전자우편,
                SMS, 카카오톡, 기타 서비스 내 팝업화면이나 공지사항, 푸시알림
                등의 방법으로 회원에 대한 통지를 할 수 있습니다.
              </li>
              <li className="number-circle-li">
                <span>②</span>
                회사는 회원 전체에 대하여 통지를 할 경우, 7일 이상 회사가
                운영하는 서비스 내의 공지사항 또는 팝업화면으로 게시함으로써
                제1항의 통지에 갈음할 수 있습니다. 다만, 회원 본인에게 중대한
                영향을 미치는 사항에 대하여는 본 조 제1항의 통지방법 중 회원에게
                개별통지(전자우편, SMS, 카카오톡 등)를 하는 방법으로 하여야
                합니다.
              </li>
              <li className="number-circle-li">
                <span>③</span>
                회사는 회원이 전자우편 주소 등을 기재하지 아니하였거나, 동
                주소를 변경한 후 수정하지 아니하는 등의 사유로 인하여 회원에게
                개별 통지를 하기 어려운 경우에 한하여 본 조 제2항에 따라
                공지사항 또는 팝업화면으로 게시함으로써 해당 회원에게 개별통지를
                한 것으로 간주합니다.
              </li>
            </ol>
          </section>
        </section>
        <hr />
        <section>
          <h2>제2장 이용계약 체결 및 서비스 이용</h2>
          <section>
            <h3>제 5 조 (이용계약의 체결 및 적용)</h3>
            <ol>
              <li className="number-circle-li">
                <span>①</span>회원이 되고자 하는 이용자는 유효한 카카오 계정을
                보유한 상태에서 회사와 서비스 이용계약을 체결하여야 합니다.
                서비스 이용계약은 이용자가 본 약관과 서비스의 제공에 필요한
                개인정보의 수집 및 이용에 동의하여 이용신청을 하면 회사가 이를
                승낙함으로써 체결됩니다.
              </li>
              <li className="number-circle-li">
                <span>②</span>회사는 회원에 대하여 「청소년보호법」 등 관련 법령
                및/또는 회사의 정책에 따라 연령별 서비스 이용 제한이나 회원의
                등급별 서비스 이용 제한을 할 수 있고, 본인인증 절차를 거치도록
                할 수 있습니다. 또한 회사는 회원이 만19세 미만 열람 불가등급의
                콘텐츠를 이용하고자 하는 경우, 관련 법령 및/또는 회사의 정책에
                따라 회원의 연령 및 본인 여부를 확인합니다.
              </li>
              <li className="number-circle-li">
                <span>③</span>회사는 이용자가 회원 등록화면에서 회사가 요구하는
                사항들을 정확히 기재하고, 카카오계정 이메일 주소의 인증 등
                회사가 정한 인증 절차를 완료한 경우 이용자의 서비스 이용 신청을
                승낙합니다. 다만, 회사는 아래 각 호에 해당하는 사유가 발생한
                경우 이용자의 서비스 이용 신청에 대한 승낙을 유보하거나,
                이용신청에 대한 승낙을 한 이후에도 제16조(회사의 계약해지 및
                이용제한)에 따라 회원의 서비스 이용을 제한하거나 이용계약을
                해지(회원 탈퇴 처리를 포함)할 수 있으며, 회원의 부정한
                이용신청으로 인하여 회사에 손해가 발생한 경우 해당 회원을 상대로
                그 손해에 대한 배상을 청구할 수 있습니다.
                <ol className="inner-ol">
                  <li>
                    <span>1.</span>
                    이용자가 본인의 실명이 아닌 이름 또는 타인의 명의를 도용하여
                    서비스 이용 신청을 한 경우
                  </li>
                  <li>
                    <span>2.</span>
                    회원 등록 또는 회원 정보 갱신 화면에 허위의 정보를
                    기재하거나, 회사가 요청하는 내용을 기재하지 않거나 회원
                    정보를 갱신하지 않은 경우
                  </li>
                  <li>
                    <span>3.</span>만 14세 미만의 이용자가 본 약관 및 서비스의
                    제공에 필요한 개인정보의 수집 및 이용에 대한 동의와 관련하여
                    이용자의 법정대리인(부모 등)의 동의를 얻지 아니한 경우
                  </li>
                  <li>
                    <span>4.</span>
                    미성년인 이용자가 「청소년보호법」 등 관련법령에 의해서
                    이용이 금지되는 서비스를 이용하고자 하는 경우
                  </li>
                  <li>
                    <span>5.</span>
                    (삭제)
                  </li>
                  <li>
                    <span>6.</span>
                    회사가 서비스 사업권 등을 허락 받지 아니한 국가에 거주, 체류
                    중인 이용자이거나, 그러한 국가의 인터넷 주소 등을 통해
                    서비스 이용 신청을 하는 경우
                  </li>
                  <li>
                    <span>7.</span>
                    범죄행위를 목적으로 서비스 이용 신청을 하였거나, 일정 기간
                    동안에 회원 가입, 탈퇴를 반복하는 등 정상적인 서비스 이용을
                    위한 목적으로 서비스 이용 신청을 하지 아니한 것이 명백한
                    경우
                  </li>
                  <li>
                    <span>8.</span>
                    회사의 서비스 제공을 방해하는 등의 사유로 과거에 회원자격이
                    상실(탈퇴)된 이력이 있는 이용자가 서비스 이용 신청을 한 경우
                  </li>
                  <li>
                    <span>9.</span>
                    카카오계정 이용계약 해지, 장기 미접속 등의 사유로
                    카카오계정이 탈퇴 처리되어 유효한 카카오 계정을 보유하지
                    않은 경우
                  </li>
                  <li>
                    <span>10.</span>
                    기타 관련 법령에 위반되어 회사가 서비스 이용 신청에 대한
                    승인이 불가하다고 판단한 경우
                  </li>
                </ol>
              </li>
              <li className="number-circle-li">
                <span>④</span>회사가 제공하는 유료서비스의 경우 이용자가 개별
                유료서비스 이용약관에 동의하고 해당 이용요금을 지급함으로써
                이용할 수 있습니다.
              </li>
            </ol>
          </section>
          <section>
            <h3>제 6 조 (회원 정보의 제공 및 변경)</h3>
            <ol>
              <li className="number-circle-li">
                <span>①</span>회원은 본 약관에 의하여 회사에 회원에 대한 정보를
                제공하여야 하는 경우에는 진실된 정보를 제공하여야 하며, 회원이
                허위정보를 제공함으로 인해 발생한 불이익에 대해서는 보호받지
                못합니다.
              </li>
              <li className="number-circle-li">
                <span>②</span>회원은 회원가입 신청 시 기재한 사항이 변경되었을
                경우 즉시 온라인을 통해 수정을 하거나 전자메일을 통한 통지 기타
                방법으로 회사에 그 변경사항을 알려야 합니다.
              </li>
              <li className="number-circle-li">
                <span>③</span>회원이 본 조 제2항의 정보 변경 사항을 회사에
                알리지 않아 발생하는 회원 및 기타 제3자의 불이익에 대하여 회사는
                고의 또는 중대한 과실이 없는 한 책임지지 않습니다.
              </li>
            </ol>
          </section>
          <section>
            <h3>제 7 조 (신원정보의 표시 및 콘텐츠의 이용조건)</h3>
            <ol>
              <li className="number-circle-li">
                <span>①</span>회사는 본 약관의 내용, 상호, 대표자 성명,
                전화번호, 팩스번호, 사업자등록번호 등을 회원이 쉽게 알 수 있도록
                서비스 화면에 순차적으로 게시합니다. 다만, 대표자 성명,
                팩스번호, 사업자등록번호 및 본 약관은 회원이 서비스 화면에서
                순차적으로 연결된 화면을 통하여 볼 수 있도록 할 수 있습니다.
              </li>
              <li className="number-circle-li">
                <span>②</span>유료서비스의 이용 조건, 콘텐츠의 이용 등급 등은 본
                약관 외에 개별 유료서비스 이용약관 및 각 콘텐츠 구매 화면을 통해
                확인할 수 있습니다.
              </li>
              <li className="number-circle-li">
                <span>③</span>원칙적으로 회원이 보유한 이용권은 해당 콘텐츠에
                대해서만 사용할 수 있습니다. 다만, 회사의 정책에 의하여 콘텐츠
                간 이용권의 이동, 거래 등을 지원하는 경우에는 해당 콘텐츠 이외
                콘텐츠에 대해서도 사용 가능할 수 있으며, 이 경우 회사는 각
                이용권의 판매 화면 등에서 별도로 안내할 수 있습니다.
              </li>
              <li className="number-circle-li">
                <span>④</span>회원은 회사가 별도로 정하여 고지한 방법 이외에는
                이용권을 회원 본인의 계정에서만 사용할 수 있으며, 제3자에게
                양도, 대여, 매매를 할 수 없습니다.
              </li>
              <li className="number-circle-li">
                <span>⑤</span>회원이 구매한 콘텐츠의 이용에 대해 상담 등이
                필요한 경우, 고객센터에 문의할 수 있습니다.
              </li>
              <li className="number-circle-li">
                <span>⑥</span>기타 청약철회, 계약해제 및 해지, 피해보상, 콘텐츠
                이용 시 제한에 대한 사항 등은 본 약관의 다른 조항 또는
                유료서비스 이용약관에서 정하는 바에 따릅니다.
              </li>
              <li className="number-circle-li">
                <span>⑦</span>회원에게 서비스되는 콘텐츠는 회원의 거주국가 또는
                서비스가 제공되는 국가에 따라서 콘텐츠의 언어 또는 일부 내용
                등이 서로 다를 수 있습니다.
              </li>
              <li className="number-circle-li">
                <span>⑧</span>콘텐츠의 연재 일정, 완결 여부, 서비스 여부 등은
                콘텐츠 저작권자의 사정에 따라 변경될 수 있습니다.
              </li>
            </ol>
          </section>
          <section>
            <h3>제 8 조 (서비스 이용시간)</h3>
            <ol>
              <li className="number-circle-li">
                <span>①</span>회사는 영업 방침에 따라 정해진 시간 동안 서비스를
                제공합니다. 별도의 표시 또는 공지가 없는 한 회사는 연중 무휴,
                1일 24시간 회원에게 서비스를 제공하는 것을 기본으로 하며, 회사는
                서비스의 제공이 일시적으로 중단됨으로 인하여 회원 또는 제3자가
                입은 손해에 대하여 배상합니다. 다만, 회사의 고의 또는 중대한
                과실이 없는 경우에는 그러하지 아니합니다.
              </li>
              <li className="number-circle-li">
                <span>②</span>본 조 제1항에도 불구하고 아래 각 호에 해당하는
                경우에는 서비스가 제공되지 아니할 수 있으며, 이 경우 회사는
                서비스를 제공할 의무가 없습니다.
                <ol className="inner-ol">
                  <li>
                    <span>1.</span>
                    컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신두절
                    또는 정기점검 등 운영상 상당한 이유가 있는 경우
                  </li>
                  <li>
                    <span>2.</span>
                    해킹 등의 전자적 침해사고, 통신사고, 회원들의 비정상적인
                    콘텐츠 이용행태, 미처 예상하지 못한 콘텐츠 서비스의 상당한
                    불안정성에 대응하기 위하여 필요한 경우
                  </li>
                  <li>
                    <span>3.</span>
                    천재지변, 전쟁, 비상사태, 정전, 설비 장애, 통신망 장애,
                    서비스 이용자 폭주 등 정상적인 서비스 제공이 불가능할 경우
                  </li>
                  <li>
                    <span>4.</span>
                    관련 법령, 정부 정책 등에서 특정 시간 동안 또는 특정한
                    방법에 따른 콘텐츠 서비스 제공을 금지하는 경우, 또는 특정
                    회원을 대상으로 하여 서비스의 제공을 금지하도록 하는 경우
                  </li>
                  <li>
                    <span>5.</span>
                    방송통신위원회, 한국정보보호진흥원 등 국가기관, 정부조직,
                    수사기관, 법원 등의 행정·사법 처분 등으로 인한 서비스 중단
                    등 회사가 통제할 수 없는 불가항력적 사유가 있는 경우
                  </li>
                  <li>
                    <span>6.</span>
                    회사의 분할, 합병, 영업양도, 영업의 폐지, 당해 서비스의 수익
                    악화 등 회사의 경영상 중대한 필요에 의한 경우
                  </li>
                </ol>
              </li>
              <li className="number-circle-li">
                <span>③</span>회사는 회사의 분할, 합병, 영업양도, 영업의 폐지,
                해당 콘텐츠 서비스의 수익 악화 등 회사의 경영상 중대한 필요에
                따라 서비스를 중단하는 경우 해당 내용을 본 약관에서 정한
                방법으로 회원에게 통지하고, 본 약관에서 정한 바 또는 관련 법령에
                따라 정하여 회사가 별도로 통지하는 바에 따라 회원에게
                보상합니다. 이 경우 회원이 무상으로 제공받은 캐시, 이용권 및
                이를 이용하여 구매한 콘텐츠는 보상대상에서 제외될 수 있습니다.
              </li>
              <li className="number-circle-li">
                <span>④</span>회사는 새로운 콘텐츠 내용, 각종 버그 패치 등
                서비스의 운영상 필요한 경우에 서비스의 전부 또는 일부를 수시로
                변경할 수 있고, 서비스 중인 콘텐츠에 대해서 완결된 회차분까지의
                지속적인 제공을 보장하지는 않습니다. 다만, 서비스의 변경, 삭제
                또는 업데이트가 회원이 제공받는 서비스의 성격상 회원에게 불리한
                것으로 판단되는 경우 회사는 본 약관에서 정한 방법에 따라
                회원에게 사전에 공지하며, 이로 인하여 회원에게 손해가 발생할
                경우 회원은 관련 법령에 따라 보상받을 수 있습니다. 단, 회사는
                콘텐츠 저작권자의 급박한 요청이 있는 등 예외적인 경우에는 먼저
                변경, 제거 등의 조치를 취한 후 회원에게 통지할 수 있습니다.
              </li>
              <li className="number-circle-li">
                <span>⑤</span>회사는 서비스의 변경으로 인한 회원의 기대수익
                상실, 회사가 직접 제공하지 않은 혜택의 상실로 인해 회원에게
                발생하는 손해에 대해서는 책임지지 않습니다.
              </li>
              <li className="number-circle-li">
                <span>⑥</span>회사는 기술상, 운영상 필요에 의해 서비스 일부 또는
                전부를 중단할 수 있으며, 이 경우 30일 전 이를 공지하고 서비스의
                제공을 중단할 수 있습니다. 단, 사전에 통지할 수 없는 부득이한
                사정이 있는 경우는 사후에 통지를 할 수 있습니다.
              </li>
            </ol>
          </section>
          <section>
            <h3>제 9조 (삭제)</h3>
          </section>
        </section>
        <hr />
        <section>
          <h2>제3장 계약당사자의 의무</h2>
          <section>
            <h3>제 10 조 (회사의 의무)</h3>
            <ol>
              <li className="number-circle-li">
                <span>①</span>회사는 관련 법령을 준수하고, 신의에 따라 성실하게
                본 약관이 정하는 권리를 행사하고 의무를 이행합니다.
              </li>
              <li className="number-circle-li">
                <span>②</span>회사는 서비스 제공 과정에서 취득한 회원의
                개인정보를 회원 본인의 승낙 없이 제3자에게 제공하지 않습니다.
                다만, 수사상의 목적 등으로 관련법령에 따라 수사기관 등으로부터
                요구 받은 경우나 방송통신심의위원회의 요청이 있는 경우 등 법률의
                규정에 따른 개인정보 제공 요청이 있는 경우에는 해당 법률에서
                정한 적법한 절차에 따라 본인의 승낙 없이 관련기관에 회원의
                정보를 제공할 수 있습니다.
              </li>
              <li className="number-circle-li">
                <span>③</span>회사는 회원이 안전하게 서비스를 이용할 수 있도록
                개인정보(신용정보 포함)를 보호하기 위해 필요한 보안시스템을
                갖추어야 하며 개인정보처리방침을 공시하고 이를 준수합니다.
              </li>
              <li className="number-circle-li">
                <span>④</span>회사는 이용자의 수, 이용시간 등을 감안하여 회원이
                원활하게 콘텐츠를 이용할 수 있도록 서버다운, 기술적 오류 등에
                대비하여 충분한 설비를 구축하고 필요한 조치를 취합니다.
              </li>
              <li className="number-circle-li">
                <span>⑤</span>회사는 회원의 불만 또는 피해구제요청을 적절하게
                처리할 수 있도록 필요한 인력 및 체계(시스템 등)를 구비합니다.
              </li>
              <li className="number-circle-li">
                <span>⑥</span>회사는 특정 회원의 불법행위 또는 약관 위반 행위
                등으로 인하여 다른 회원들에게 동일 또는 유사한 피해가 계속하여
                발생하고 있는 사실을 인식한 경우 회원의 추가적인 피해를 예방하기
                위하여 초기화면이나 공지사항 등에서 그 피해발생 사실과
                피해예방을 위한 회원의 조치사항 등에 대하여 공지합니다.
              </li>
            </ol>
          </section>
          <section>
            <h3>제 11 조 (회원의 의무)</h3>
            <ol>
              <li className="number-circle-li">
                <span>①</span>회원은 서비스 이용 시 본 약관에서 규정하는 사항,
                운영정책 및 이용제한 규정, 기타 회사가 정한 제반 규정, 회사가
                팝업화면 등을 이용하여 사전에 회원에게 공지하는 사항 및
                「정보통신망 이용촉진 및 정보보호 등에 관한 법률」,
                「저작권법」, 「청소년보호법」 등 관계법령을 준수하여야 합니다.
              </li>
              <li className="number-circle-li">
                <span>②</span>회원은 다음 각 호의 행위를 하여서는 안 됩니다.
                <ol className="inner-ol">
                  <li>
                    <span>1.</span>
                    서비스 이용 신청 또는 변경 시 필요한 정보를 허위로
                    등록하거나, 다른 회원의 아이디(ID) 및 비밀번호를 사용하는 등
                    타인의 정보를 도용하는 행위
                  </li>
                  <li>
                    <span>2.</span>
                    서비스 이용 과정에서 다른 회원의 개인정보를 수집, 저장,
                    공개하는 행위
                  </li>
                  <li>
                    <span>3.</span>
                    회원 자신 또는 타인에게 재산상의 이익을 얻게 할 목적 또는
                    타인에게 손해를 가할 목적으로 서비스 게시판 등에 허위의
                    정보를 유통시키는 행위
                  </li>
                  <li>
                    <span>4.</span>
                    회사가 회원에게 제공하는 콘텐츠를 회사의 사전 승낙 없이 복제
                    또는 유통시키는 행위
                  </li>
                  <li>
                    <span>5.</span>
                    회사가 제공하는 콘텐츠를 서비스 내에서 회원의 사적 감상
                    목적으로 이용하는 것 외에, 공공장소 및 영리를 목적으로 하는
                    영업장, 매장 등에서 회사가 제공하는 서비스 화면을 노출시키는
                    등의 방법으로 이용하는 행위
                  </li>
                  <li>
                    <span>6.</span>
                    서비스 이용 과정에서 저작권자 등 타인의 명예를 손상시키거나
                    모욕하는 행위 등을 포함하여 타인에게 불이익을 야기할 수 있는
                    일체의 행위
                  </li>
                  <li>
                    <span>7.</span>
                    서비스 게시판 등에 음란물을 게재하거나 음란사이트를
                    연결(링크)하는 행위 또는 서비스 게시판 등을 통해 법령과
                    약관에 위반되는 내용의 정보, 문장, 도형, 음성 등을 타인에게
                    유포하는 행위
                  </li>
                  <li>
                    <span>8.</span>
                    서비스 이용 과정에서 타인으로 가장하는 행위 및 타인과의
                    관계를 허위로 명시하는 행위
                  </li>
                  <li>
                    <span>9.</span>
                    회사의 직원이나 운영자를 가장하거나 사칭하여 또는 타인의
                    명의를 도용하여 서비스 게시판 등에 글을 게시하거나 타
                    회원에게 메일을 발송하는 행위
                  </li>
                  <li>
                    <span>10.</span>
                    회사로부터 특별한 권리를 부여 받지 않고 서비스 관련 프로그램
                    또는 웹사이트를 변경하거나 서비스 내 다른 프로그램 등을 추가
                    또는 삽입하는 행위 또는 서비스에 게시된 정보를 변경하는 행위
                  </li>
                  <li>
                    <span>11.</span>
                    서비스와 관련된 설비의 오동작이나 정보 등의 파괴 및 혼란을
                    유발시킬 수 있는 행위(예: 컴퓨터 바이러스, 또는 바이러스에
                    감염된 자료를 고의적으로 등록 또는 유포하는 등의 행위,
                    데이터가 있는 웹페이지의 정보를 대량으로 수집하거나
                    정보통신망에 명령을 자동으로 반복 입력하는 프로그램 등을
                    이용하여 서비스와 관련된 회사의 지식재산권을 침해하거나
                    설비의 오작동을 야기시킬 수 있는 행위 등)
                  </li>
                  <li>
                    <span>12.</span>
                    자신의 서비스 계정을 제3자에게 공유하여 사용하도록 하는
                    행위, 동일한 계정으로 회사의 운영정책에서 정하는 수 이상의
                    접근기기에서 동시에 접속하는 행위, 동일한 접근기기에서
                    회사의 운영정책에서 정하는 수 이상의 계정을 생성하여
                    접속하는 행위 등을 포함하여 회사가 제공하는 정상적인 서비스
                    이용 방법과 상반되는 행위
                  </li>
                  <li>
                    <span>13.</span>
                    이벤트 참가 등의 반대급부로 회사가 회원에게 무상으로
                    지급하는 캐시, 이용권 등의 재화를 부당하게 수령할 목적으로
                    또는 특정 콘텐츠의 이용을 유도 또는 방해할 목적으로
                    (ⅰ)다수의 계정을 생성하여 서비스에 접속하거나, (ⅱ)동일한
                    댓글 등을 대량으로 작성하거나, (ⅲ)이벤트에 참가하여 캐시,
                    이용권을 지급받은 후 캐시, 이용권의 지급 대가인 이벤트 대상
                    거래 등을 취소하는 행위
                  </li>
                  <li>
                    <span>14.</span>
                    회사 기타 제3자의 지식재산권을 침해하는 행위
                  </li>
                  <li>
                    <span>15.</span>
                    회사의 사전 동의 없이 서비스 내 광고성 정보를 전송하는 등
                    회사가 제공하는 서비스를 회원 자신의 영리목적으로
                    무단이용하는 행위
                  </li>
                  <li>
                    <span>16.</span>
                    서비스 이용 과정에서 회사의 업무를 방해하거나 회사의 명예를
                    손상시키는 행위
                  </li>
                  <li>
                    <span>17.</span>
                    서비스 이용 과정에서 불법적인 행위
                  </li>
                  <li>
                    <span>18.</span>
                    회사의 고객센터 등에 대한 문의 및 상담 과정에서 욕설, 폭언,
                    성희롱, 불필요한 반복적인 민원으로 인한 업무방해 등에
                    해당하는 행위
                  </li>
                  <li>
                    <span>19.</span>기타 위 각 호에 준하는 행위
                  </li>
                </ol>
              </li>
              <li className="number-circle-li">
                <span>③</span>회원이 본 조 제2항에 명시된 회원의 의무에 반하는
                행위를 한 경우 또는 기타 고의나 과실로 회사 서비스의 정상적인
                운영을 방해하거나 회사에 손해를 입힌 경우 회사는 제16조(회사의
                계약해지 및 이용제한)에서 정한 바에 따라 회원과 체결한 서비스
                이용계약을 해지하거나, 회원의 서비스 이용을 제한 또는 중지할 수
                있습니다.
              </li>
            </ol>
          </section>
          <section>
            <h3>제 12 조 (광고의 게재 및 발송)</h3>
            <ol>
              <li className="number-circle-li">
                <span>①</span>회사는 회원이 동의한 경우에 한하여 카카오톡, SMS,
                푸시알림 등을 통해 광고성 정보를 발송할 수 있습니다. 광고성
                정보의 경우 회원이 원하지 않는 경우에 언제든지 수신을 거부할 수
                있으며, 회사는 회원의 수신 거부 시 광고성 정보를 발송하지
                않습니다.
              </li>
              <li className="number-circle-li">
                <span>②</span>회사는 본 조 제1항에 따른 광고성 정보 발송 외에
                서비스 화면, 홈페이지, 전자우편 등에 직접 또는 제휴 관계에 있는
                제3자(이하 본 조에서는 "광고주"라 합니다)를 통해 광고를 게재할
                수 있으며 서비스를 이용하고자 하는 회원은 서비스 이용 시
                노출되는 광고 게재에 대해 동의하는 것으로 간주됩니다.
              </li>
              <li className="number-circle-li">
                <span>③</span>회사는 서비스에 게재되어 있는 광고를 이용하거나,
                서비스를 통한 광고주의 판촉 활동에 회원이 참여하는 등의 방법으로
                교신 또는 거래를 하는 것은 전적으로 회원과 광고주 사이의
                문제이므로, 만약 회원과 광고주 사이에 어떠한 문제가 발생할
                경우에도 회원과 광고주가 직접 해결하여야 하며, 이와 관련하여
                회사는 고의 또는 중과실이 없는 한 책임을 지지 않습니다.
              </li>
            </ol>
          </section>
          <section>
            <h3>제 13 조 (저작권 기타 법적 권리)</h3>
            <ol>
              <li className="number-circle-li">
                <span>①</span>회원이 서비스를 이용하면서 게시한 저작물
                등(게시글, 닉네임, 댓글 등을 포함함, 이하 '이용자 게시물'이라
                합니다)에 대한 권리와 책임은 회원 본인에게 있습니다.
              </li>
              <li className="number-circle-li">
                <span>②</span>회사가 작성한 저작물에 대한 저작권 기타
                지식재산권은 회사에 귀속합니다. 단 회원의 게시물 및 제3자와의
                제휴계약에 의해 제공된 저작물 등은 제외합니다.
              </li>
              <li className="number-circle-li">
                <span>③</span>회원은 회사가 제공하는 콘텐츠 중 회사 또는 회사에
                콘텐츠를 제공한 업체에 지식재산권이 귀속된 콘텐츠를 회사 또는
                제공업체의 사전승낙 없이 복제, 전송, 출판, 배포, 방송 기타
                방법에 의하여 이용하거나 제3자에게 이용하게 하여서는 안 됩니다.
              </li>
              <li className="number-circle-li">
                <span>④</span>회사가 제공하는 콘텐츠는 대한민국을 포함한 각
                국가의 저작권법, 국제 지식재산권 관련 조약에 따라 보호받으며,
                회사가 저작권자 등 회사에 콘텐츠를 제공한 업체로부터 이용 또는
                사용을 허락 받아 회원의 이용에 제공하는 유료 서비스에 대해서는
                콘텐츠를 제공한 업체의 국적 국가의 법 및 조약이 적용될 수
                있습니다.
              </li>
              <li className="number-circle-li">
                <span>⑤</span>회원은 이용자 게시물에 대하여 회사가 다음과 같은
                방법과 조건으로 이용하는 것을 허락합니다.
                <ol className="inner-ol">
                  <li>
                    <span>1.</span>
                    서비스 프로모션을 위해 필요한 범위에서의 이용자 게시물의
                    활용(콘텐츠 홍보물 작성을 위하여 이용자 게시물을 편집,
                    수정하여 활용하거나, 종이책 출판 시 표지 등에 활용하는 방법
                    등). 다만, 회원은 언제든지 사용 중단을 요청할 수 있으며
                    회사는 사용 중단 요청을 받은 이후부터는 활용하지 않습니다.
                  </li>
                  <li>
                    <span>2.</span>
                    서비스의 향상을 위한 통계분석 등 연구목적으로 활용(콘텐츠
                    기획, 사용자 환경 개선 등을 위한 통계자료로서 활용하는 방법
                    등)
                  </li>
                </ol>
              </li>
              <li className="number-circle-li">
                <span>⑥</span>서비스 외부에 게재된 콘텐츠 등 서비스와 일체화되지
                않은 회원의 이용자 게시물에 대하여 회사는 회원의 명시적인 동의
                없이 상업적으로 이용하지 않으며, 회원은 언제든지 이러한 이용자
                게시물을 삭제할 수 있습니다.
              </li>
              <li className="number-circle-li">
                <span>⑦</span>회사는 특정 이용자 게시물이 아래 각 호에 해당하는
                경우 그 게시자에게 사전 통지하고 해당 게시물에 대해서
                임시조치(삭제, 블라인드 처리, 내용변경 등)를 할 수 있습니다. 단,
                아래 사유에 해당하는 것이 객관적으로 명백하거나 긴급한 조치가
                필요한 경우에는 사전통지 없이 임시조치를 할 수 있으며 사후
                통지합니다. 그 이후에는 당사자간 합의와 관련 법령 및/또는 회사의
                정책에 따라 이를 삭제 또는 복원할 수 있습니다.
                <ol className="inner-ol">
                  <li>
                    <span>1.</span>
                    명예훼손(모욕 포함), 사생활 침해, 저작권 침해 등을 포함하여
                    타인의 권리를 침해(권리침해가 발생할 가능성이 있는 사유가
                    있는 경우 포함)
                  </li>
                  <li>
                    <span>2.</span>
                    법령에 위반되거나 위반의 소지가 있다고 판단되는 경우
                  </li>
                  <li>
                    <span>3.</span>
                    외설·폭력적인 내용이 포함되어 있다고 판단되는 경우
                  </li>
                  <li>
                    <span>4.</span>
                    기타 이에 준하는 사유에 해당하는 경우
                  </li>
                </ol>
              </li>
              <li className="number-circle-li">
                <span>⑧</span>회사의 서비스 내에 게시된 이용자 게시물로 인하여
                법률상 이익이 침해된 회원은 고객센터 또는 별도 마련한 창구를
                통해 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 및
                「저작권법」 등 관련 법령이 정한 절차에 따라 해당 이용자
                게시물의 게시 중단 및 삭제 등을 요청할 수 있습니다. 이 경우
                회사는 지체 없이 필요한 조치를 취하고 그 결과를 회원에게
                통지합니다.
              </li>
              <li className="number-circle-li">
                <span>⑨</span>회원은 제7항에 따른 임시조치가 있은 후 7일 내에
                이의신청을 할 수 있습니다. 다만, 「정보통신망 이용촉진 및
                정보보호 등에 관한 법률」 등 관련 법령에 이의신청 기간이 더 길게
                정해져있는 경우 해당 법령에 따릅니다.
              </li>
            </ol>
          </section>
        </section>
        <hr />
        <section>
          <h2>제4장 청약철회, 계약해지 및 이용제한 등</h2>
          <section>
            <h3>제 14 조 (회원의 청약 철회 및 계약해지 등)</h3>
            <p>
              회원은 서비스 페이지상의 메뉴 또는 고객센터, 기타 전자우편 등을
              통해 청약철회("철회"란 회원이 구입 후 아직 사용하지 않은 캐시 또는
              이용권을 환불 받는 것과 같이, 회원이 서비스를 이용하기 이전에
              앞으로 서비스를 이용하지 않을 의사로 법률행위의 효과를 발생하지
              않도록 하는 것을 말합니다) 및 이용계약 해지("해지"란 회원 탈퇴와
              같이 일방의 일방적 의사표시에 의하여 의사표시 시점 이후에 서비스
              이용계약의 효력을 장래를 향하여 소멸시키는 것을 말합니다) 신청을
              할 수 있으며, 회사는 회원이 청약의 철회 또는 계약의 해지를 요청한
              경우 이를 지체없이 처리하고 개인정보처리방침에 따라 필요한 경우
              회원의 정보를 파기합니다.
            </p>
          </section>
          <section>
            <h3>제 15 조 (삭제)</h3>
          </section>
          <section>
            <h3>제 16 조 (회사의 계약해지 및 이용제한)</h3>
            <ol>
              <li className="number-circle-li">
                <span>①</span>회사는 회원이 법령 또는 본 약관 위반, 기타 고의
                또는 과실로 회사 서비스의 정상적인 운영을 방해하거나 회사에
                손해를 입힌 경우 회원에게 이용제한의 사유 및 이용제한의 범위와
                적용일, 이의신청 절차 등을 사전에 통지하고 서비스의 전부 또는
                일부의 이용을 일시 또는 영구적으로 제한할 수 있습니다.
              </li>
              <li className="number-circle-li">
                <span>②</span>회사는 회원의 중대한 법령 위반 또는 약관 위반으로
                인하여 회원의 향후 서비스 이용이 불가하다고 판단되는 경우
                회원에게 해지사유 및 해지기준일, 이의신청 절차 등을 사전 통보한
                이후 이용제한 조치에 더하여 서비스 이용계약을 해지할 수
                있습니다.
              </li>
              <li className="number-circle-li">
                <span>③</span>회사는 본 조 제1, 2항에도 불구하고 회원이 현행법
                위반 및 고의 또는 중대한 과실로 회사에 손해를 끼치거나, 긴급한
                이용제한 조치의 필요성이 인정되는 경우 회사는 즉시 이용제한 및
                계약해지 조치를 먼저 취하고 사후에 회원에게 통지할 수 있습니다.
              </li>
              <li className="number-circle-li">
                <span>④</span>회원은 회사의 조치에 대하여 회사가 정한 절차에
                따라 이의신청할 수 있습니다. 이때 이의가 정당하다고 인정되는
                경우 회사는 즉시 조치를 철회합니다.
              </li>
              <li className="number-circle-li">
                <span>⑤</span>회사는 이용제한 및 계약해지 조치된 회원의 이용자
                게시물(글, 사진, 영상 등)에 대하여 삭제 등 조치를 취할 수
                있습니다.
              </li>
              <li className="number-circle-li">
                <span>⑥</span>회사는 이용제한으로 인하여 회원이 손해를 입은 경우
                회원이 입은 손해를 합리적인 범위 내에서 배상합니다. 다만,
                이용제한이 정당한 경우에는 배상하지 않습니다.
              </li>
              <li className="number-circle-li">
                <span>⑦</span>서비스 이용계약이 해지되어 회사가 회원에게
                사용하지 않은 캐시 및 이용권에 대하여 환불하여야 하는 경우
                회원이 회원가입 이후 유료서비스로 얻은 이익 및 환불수수료(해당
                환불금액의 10% 또는 1,000원 중 큰 금액)를 공제한 잔액을
                환불합니다. 다만, 회원의 위반행위로 인하여 회사에 금전적 손해가
                발생한 경우 환불금액에서 회사의 손해를 공제하는 등 환불이 제한될
                수 있습니다.
              </li>
            </ol>
          </section>
          <section>
            <h3>제 17 조 (손해배상)</h3>
            <ol>
              <li className="number-circle-li">
                <span>①</span>회사가 고의 또는 중과실로 회원에게 손해를 끼친
                경우, 손해에 대하여 배상할 책임이 있습니다. 회원이 본 약관상
                의무를 위반하거나 현행 법규를 위반하는 등 책임 있는 사유로
                회사에 손해를 입힌 경우에 회원은 회사에 대하여 위반행위로 인하여
                발생한 손해를 배상하여야 합니다.
              </li>
              <li className="number-circle-li">
                <span>②</span>회사는 회사가 무료로 제공하는 서비스와 관련하여
                회원에게 발생한 손해에 대해서 책임지지 않습니다. 다만, 회사의
                고의 또는 중대한 과실로 인하여 발생한 손해의 경우는 제외합니다.
              </li>
            </ol>
          </section>
        </section>
        <hr />
        <section>
          <h2>제5장 기타</h2>
          <section>
            <h3>제 18 조 (회사의 면책)</h3>
            <ol>
              <li className="number-circle-li">
                <span>①</span>회사는 천재지변 또는 국가비상사태, 정전, COVID-19
                와 같은 중대한 전염성 질병의 대유행, 회사에게 고의 또는 중과실이
                없는 기간통신사업자의 회선 장애 및 이에 준하는 불가항력 상황이
                발생함으로 인하여 회사가 서비스를 제공할 수 없는 경우에는,
                책임이 면제됩니다.
              </li>
              <li className="number-circle-li">
                <span>②</span>회사는 회원의 귀책사유로 인한 서비스 이용제한,
                이용자 게시물 삭제, 서비스 장애, 계약 해지 등에 대하여는 책임을
                지지 않습니다.
              </li>
              <li className="number-circle-li">
                <span>③</span>회사는 정보통신망 이용환경 관련 문제 또는 회원의
                모바일기기, PC 등의 각종 유무선 장치의 사용 환경으로 인하여
                발생하는 제반 문제에 대해서는 회사의 고의 또는 중대한 과실이
                없는 한 책임을 지지 않습니다.
              </li>
              <li className="number-circle-li">
                <span>④</span>회사는 회원이 서비스와 관련하여 게재한 정보, 자료
                등의 신뢰도, 정확성에 관하여는 회사의 고의 또는 중대한 과실이
                없는 한 책임을 지지 않습니다.
              </li>
              <li className="number-circle-li">
                <span>⑤</span>회사는 회원이 본인의 개인정보 등(계정 포함)을
                변경함에 따라 발생하는 일체의 불이익에 대해 회사의 고의 또는
                중대한 과실이 없는 한 책임을 지지 않습니다.
              </li>
              <li className="number-circle-li">
                <span>⑥</span>회사는 회원 간 또는 회원과 제3자 상호간에 서비스를
                매개로 하여 맺은 거래관계 등에 대해 책임을 지지 않습니다.
              </li>
            </ol>
          </section>
          <section>
            <h3>제 19 조 (약관 외 준칙)</h3>
            <ol>
              <li className="number-circle-li">
                <span>①</span>회사는 본 약관 외에도 개별 서비스 약관 및
                운영정책을 둘 수 있으며, 해당 내용이 본 약관과 상충할 경우에는
                개별 서비스 약관 및 운영정책이 우선하여 적용됩니다. 개별 서비스
                약관과 운영정책은 회원이 쉽게 볼 수 있는 곳에 고지합니다.
                운영정책의 개정이 회원의 권리 또는 의무에 중대한 변경을 가져오는
                경우 제3조에 의하여 개정합니다. 다만, 회원의 권리 의무와 관련
                없는 사항을 개정하거나, 약관에서 정한 내용과 근본적으로 다르지
                아니하고 회원이 예측가능한 범위에서 개정되는 경우에는 운영정책
                화면 내의 공지로 갈음합니다.
              </li>
              <li className="number-circle-li">
                <span>②</span>본 약관이 정하지 아니한 사항이나 본 약관의 해석에
                대해서는 개별 서비스 약관 및 「전자상거래 등에서의 소비자보호에
                관한 법률」, 「약관의 규제에 관한 법률」, 「콘텐츠산업진흥법」,
                「정보통신망이용촉진 및 정보보호 등에 관한 법률」,
                「콘텐츠이용자보호지침」, 「소비자분쟁해결기준」 등 관계법령에
                따릅니다.
              </li>
            </ol>
          </section>
          <section>
            <h3>제 20 조 (분쟁조정의 신청)</h3>
            <ol>
              <li className="number-circle-li">
                <span>①</span>회사는 회원이 제기하는 정당한 의견이나 불만을
                반영하고 그 피해를 처리하기 위하여 고객센터를 운영합니다.
              </li>
              <li className="number-circle-li">
                <span>②</span>회사는 분쟁이 발생하였을 경우에 이용자가 제기하는
                정당한 의견이나 불만을 반영하여 적절하고 신속한 조치를 취합니다.
                다만, 신속한 처리가 곤란한 경우에 회사는 이용자에게 그 사유와
                처리일정을 통보합니다.
              </li>
              <li className="number-circle-li">
                <span>③</span>본조 제1항에도 불구하고 협의에 이르지 못한 경우,
                회원은 「콘텐츠산업 진흥법」 제30조 제1항에 따라 콘텐츠 이용과
                관련한 피해의 구제와 분쟁의 조정을 위하여 콘텐츠분쟁조정위원회에
                분쟁조정을 신청할 수 있습니다.
              </li>
            </ol>
          </section>
          <section>
            <h3>제 21 조 (준거법 및 재판관할)</h3>
            <ol>
              <li className="number-circle-li">
                <span>①</span>본 약관 제20조에서 정한 절차를 통해서도 회사와
                회원 사이의 분쟁이 해결되지 않을 경우, 양 당사자는 소를 제기할
                수 있으며, 회사와 회원간 제기된 소송은 대한민국 법을 준거법으로
                합니다.
              </li>
              <li className="number-circle-li">
                <span>②</span>회사와 회원간 발생한 분쟁에 관한 재판 관할은
                「민사소송법」 상의 관할 규정에 따릅니다.
              </li>
            </ol>
          </section>
        </section>
      </main>
      <footer>
        <p>부칙</p>
        <p>
          공고일자 : 2026년 3월 10일
          <br />
          시행일자 : 2026년 5월 11일
        </p>
      </footer>
    </>
  );
}
